<template>
  <GhostPost />
</template>

<script setup lang="ts">
definePageMeta({
  i18n: {
    paths: {
      en: '/blog/[slug]',
      fr: '/blogue/[slug]',
    },
  },
})

const route = useRoute()
const { locale } = useI18n()
const slug = computed(() => route.params.slug)

const setI18nParams = useSetI18nParams()
setI18nParams({
  en: locale.value === 'en'
    ? {
        slug: slug.value,
      }
    : false,
  fr: locale.value === 'fr'
    ? {
        slug: slug.value,
      }
    : false,
})

onBeforeRouteLeave(() => {
  setI18nParams({})
})
</script>
